/**
 * @generated SignedSource<<3c344a703b6770f1a8be04330639bdf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskContactSupportSearch_viewer$data = {
  readonly zendeskArticles: {
    readonly supportArticlesSearch?: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskContactSupportSearch_viewer";
};
export type GetHelpZendeskContactSupportSearch_viewer$key = {
  readonly " $data"?: GetHelpZendeskContactSupportSearch_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskContactSupportSearch_viewer">;
};

import GetHelpZendeskContactSupportSearchRefetchQuery_graphql from './GetHelpZendeskContactSupportSearchRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contactSupportSearchQuery"
    },
    {
      "kind": "RootArgument",
      "name": "hasContactSupportSearchQuery"
    },
    {
      "kind": "RootArgument",
      "name": "isSeller"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": GetHelpZendeskContactSupportSearchRefetchQuery_graphql
    }
  },
  "name": "GetHelpZendeskContactSupportSearch_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isSeller",
          "variableName": "isSeller"
        },
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        }
      ],
      "concreteType": "Contact1stdibsZendeskArticles",
      "kind": "LinkedField",
      "name": "zendeskArticles",
      "plural": false,
      "selections": [
        {
          "condition": "hasContactSupportSearchQuery",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "supportArticlesSearch",
              "args": [
                {
                  "kind": "Variable",
                  "name": "query",
                  "variableName": "contactSupportSearchQuery"
                }
              ],
              "concreteType": "ZendeskArticle",
              "kind": "LinkedField",
              "name": "articles",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "efeb20f878e114f553451ec0249d490a";

export default node;
